var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.child || _vm.child.appearance_status?.type === 'check_in')?_c('custom-radio',{attrs:{"custom-class":"colorful daily-report-types mt-3","items":_vm.reportTypes,"type":"grid"},model:{value:(_vm.selectedReportType),callback:function ($$v) {_vm.selectedReportType=$$v},expression:"selectedReportType"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }